/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-19 22:59:45
 * @LastEditTime: 2022-01-21 17:40:37
 * @LastEditors: zhao - 🍉
 * @Description: 更新客户昵称
 * @FilePath: /zhzj-admin/src/page/CustomerServices/CustomerList/components/UpdateCustomerModal.jsx
 */


import { Input, message, Modal } from 'antd';
import React, { useState, useRef } from 'react'
import { CustomCol, CustomRow } from '../../../../components/Custom';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchWechatServicesCustomerInfoUpdate } from '../../../../services/wechatServices';
const UpdateCustomer = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    let callback = useRef(null);
    const [customerData, setCustomerData] = useState({});

    const open = (customerData) => {
        setVisible(true)
        setCustomerData(customerData)
        return new Promise((resolve,reject) => {
            console.log(callback)
            callback.current = resolve
           
        })
    }
    const close = () => {
        setVisible(false)
    }
    const postSubmit = (data) => {
        setLoading(true)
        return fetchWechatServicesCustomerInfoUpdate(data).then(res => {
            message.success('保存成功')
        }).finally(() => {
            setLoading(false)
        })
    }
    const handleChange = (e) => {
        setCustomerData({...customerData, buyer_nickname: e.target.value})
    }

    const handleSubmit = () => {
        
        if (loading) return
        if (!customerData.buyer_nickname) return message.warning('请输入昵称')
        const data = {
            openId: customerData.openid,
            guideAccount: customerData.guide_account,
            buyerNickname: customerData.buyer_nickname,
        }
        postSubmit(data).then(() => {
            callback.current()
            close()
        })
    }

    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="更改昵称" 
            width={650} 
            visible={visible} 
            confirmLoading={loading}
            onCancel={close} 
            onOk={handleSubmit}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <CustomRow divider>
                        <CustomCol label="新昵称" colStyle={{ width: 500 }}>
                            <Input value={customerData.buyer_nickname} onChange={handleChange} />
                        </CustomCol>
                       
                    </CustomRow>
                   
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default UpdateCustomer



// WEBPACK FOOTER //
// ./src/page/CustomerServices/CustomerList/components/UpdateCustomerModal.jsx